// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"author_byline-module__sr-only___80d9r","byline":"author_byline-module__byline___OZLFm","small":"author_byline-module__small___-6xvR"};